import FieldWrapper from './field-wrapper';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js';
import moment from 'moment';
import Flatpickr from 'react-flatpickr';
import { useController, UseControllerProps, FieldValues, useFormContext } from 'react-hook-form';

/** @deprecated Use DateInputField instead. */
export interface DateFieldProps<T extends FieldValues> extends UseControllerProps<T> {
  label?: string;
  isSmallSize?: boolean;
  disabled?: boolean;
  placeholder?: string;
  dateFormat?: string;
  altFormat?: string;
  showError?: boolean;
  monthYearOnly?: boolean;
}

/** @deprecated Use DateInputField instead. */
export const DateField = <T extends FieldValues>({
  label,
  isSmallSize,
  disabled,
  placeholder = 'Select Date...',
  dateFormat = 'Y-m-d',
  altFormat = 'd/m/Y',
  showError = true,
  monthYearOnly = false,
  ...props
}: DateFieldProps<T>) => {
  const { trigger } = useFormContext();
  const currentFormat = 'YYYY-MM-DD';

  const {
    field,
    fieldState: { error }
  } = useController({
    ...props
  });

  const formatDate = (date: Date) => {
    return moment(date).format(currentFormat);
  };

  const flatpickrOptions: any = {
    dateFormat: monthYearOnly ? 'Y-m-d' : dateFormat,
    altInput: true,
    altFormat: monthYearOnly ? 'M Y' : altFormat,
    disableMobile: true,
    appendTo: document.body,
    locale: {
      firstDayOfWeek: 1
    }
  };

  if (monthYearOnly) {
    flatpickrOptions.plugins = [
      monthSelectPlugin({
        shorthand: true,
        dateFormat: 'Y-m-d',
        altFormat: 'M Y'
      })
    ];
  }

  return (
    <FieldWrapper label={label} error={error} showError={showError}>
      <Flatpickr
        key={`${field.name}-${disabled}`}
        disabled={disabled}
        placeholder={placeholder}
        className={`form-control form-control-solid ${isSmallSize ? 'form-control-sm' : ''} ${
          error ? 'is-invalid' : ''
        }`}
        value={field.value ? moment(field.value, currentFormat).toDate() : undefined}
        onChange={(dates) => {
          if (dates.length > 0) {
            const selectedDate = dates[0];
            const formattedDate = formatDate(selectedDate);
            field.onChange(formattedDate);
          } else {
            field.onChange(null);
          }
          trigger(field.name);
        }}
        options={flatpickrOptions}
      />
    </FieldWrapper>
  );
};
